import React from 'react';
import classNames from 'classnames';
import ABSIcon from '../ABSIcon';
import { Input as AntdInput } from 'antd';
import { IInputProps } from './interface';
import ABSField from '../ABSField';
import './index.less';

interface IABSInputState {
  type?: string;
}

class ABSInput extends React.Component<IInputProps, IABSInputState> {
  constructor(props: any) {
    super(props);
    const { type = 'text' } = this.props;
    this.state = {
      type
    };
  }
  
  /**
   * 渲染方法
   */

  renderIconButton = () => {
    const { isSuffix, onDelete, value, type } = this.props;
    if (isSuffix && type === 'password') {
      return (
        <div onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
          <ABSIcon isAnt={true} type="eye" />
        </div>
      );
    }
    if (!isSuffix || !value || !onDelete) {
      return null;
    }
    return (
      <ABSIcon
        isAnt={true}
        type="close-circle"
        onClick={onDelete}
      />
    );
  };

  render() {
    const {
      style,
      className,
      emptyClassName,
      defaultValue,
      value,
      placeholder,
      disabled,
      size,
      prefix,
      addonAfter,
      addonBefore,
      onPressEnter,
      onChange,
      onBlur,
      onFocus,
      result,
      title, 
      required, 
      labelWidth, 
      removePaddingLeft,
      removeMarginBottom,
      isVertical,
      contentWidth,
      desc,
      onKeyUp,
      onPaste,
      refs
    } = this.props;

    const { type } = this.state;
    const clazz = classNames(
      'abs-input',
      `abs-input-size-${size}`,
      {'abs-input-empty': emptyClassName},
      className
    );

    return (
      <ABSField
        result={result}
        className={clazz}
        title={title}
        required={required}
        labelWidth={labelWidth}
        removePaddingLeft={removePaddingLeft}
        removeMarginBottom={removeMarginBottom}
        desc={desc}
        isVertical={isVertical}
        contentWidth={contentWidth}
      >
        <AntdInput
          style={style}
          type={type}
          size={size}
          value={value}
          prefix={prefix}
          placeholder={placeholder}
          defaultValue={defaultValue}
          disabled={disabled}
          addonAfter={addonAfter}
          addonBefore={addonBefore}
          suffix={this.renderIconButton()}
          onChange={onChange}
          onPressEnter={onPressEnter}
          onBlur={onBlur}
          onFocus={onFocus}
          onKeyUp={onKeyUp}
          onPaste={onPaste}
          ref={refs}
        />
      </ABSField>
    );
  }

  onMouseEnter = () => this.setState({ type: 'default' });

  onMouseLeave = () => this.setState({ type: 'password' });
}

export default ABSInput;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSInput/Input.tsx